import { TableState } from './table-state';
import { TableStateContext } from './table-state-context';
import { useContext } from 'react';

export const useTableState = (): TableState => useContext(TableStateContext);
